import { resolveNavigation } from './navigation/resolve-navigation.js';
import type { NavigationContext } from './navigation/types.js';
import type { DbTagRow } from './types.js';

export function resolvePythonDefinitions(ctx: NavigationContext): DbTagRow[] {
  return resolveNavigation(ctx).definitions;
}
